import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

/** vee validate **/
import en from "./utils/validator/messages/en";
import {extend, localize, ValidationObserver, ValidationProvider} from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'

/** FontAwesome set up **/
import {library} from '@fortawesome/fontawesome-svg-core'
import { faClipboard, faSpinner } from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'

/** vee validate **/
Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
// install rules
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule])
});
// add the dictionary
localize('en', en);

/** FontAwesome set up **/
library.add(faClipboard, faSpinner)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
